import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Switch } from '@/components/ui/switch';

interface SaveViewDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onSave: (name: string, isShared: boolean) => void;
  defaultName?: string;
}

const SaveViewDialog: React.FC<SaveViewDialogProps> = ({
  isOpen,
  onClose,
  onSave,
  defaultName = '',
}) => {
  const [name, setName] = useState(defaultName);
  const [isShared, setIsShared] = useState(false);

  const handleSave = () => {
    if (!name.trim()) return;
    onSave(name.trim(), isShared);
    setName('');
    setIsShared(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={(open) => !open && onClose()}>
      <DialogContent className="sm:max-w-[400px]">
        <DialogHeader>
          <DialogTitle>Weergave opslaan</DialogTitle>
        </DialogHeader>
        <div className="space-y-4 py-2">
          <div className="space-y-2">
            <Label htmlFor="view-name">Naam</Label>
            <Input
              id="view-name"
              value={name}
              onChange={(e) => setName(e.target.value)}
              placeholder="Bijv. Actieve voorzieningen per gebouw"
              autoFocus
            />
          </div>
          <div className="flex items-center justify-between">
            <Label htmlFor="view-shared" className="cursor-pointer">
              Gedeeld met collega's
            </Label>
            <Switch
              id="view-shared"
              checked={isShared}
              onCheckedChange={setIsShared}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={onClose}>Annuleren</Button>
          <Button onClick={handleSave} disabled={!name.trim()}>Opslaan</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default SaveViewDialog;
